goog.provide('el8.appchart.dialog.addEditImplantableDevice');

goog.require('el8.appshared.mindreaderOpts');
goog.require('el8.data.cptCodes');
goog.require('el8.ptdata.implantableDevices');
goog.require('el8.uiwidget.FormDialog');
goog.require('el8.uiwidget.Form');
goog.require('el8.uiwidget.alert');
goog.require('el8.template.appchart.dialog.addEditImplantableDevice');
goog.require('el8.service.infoField');
goog.require('el8.util.consts');
goog.require('el8.appshared.form.buttons');

el8.appchart.dialog.addEditImplantableDevice = (function() {

    var currImplantableDevice = null;

    var that = new el8.uiwidget.FormDialog({
        title: 'Implantable Device',
        autoHeight: true,
        width: 600,
        showXButton: true,
        contentFn: function() {
            return el8.template.appchart.dialog.addEditImplantableDevice.form({
                statusChoices: el8.util.consts.IMPLANTABLE_DEVICE_STATUS_CHOICES
            });
        }
    });

    var form = new el8.uiwidget.Form({
        fields: [
            {
                name: 'udi',
                selector: ':input[name="udi"]',
                infoText: '',
                maxLength: 255,
                height: el8.util.consts.XL_FIELD_HEIGHT,
                validate: {
                    required: true
                }
            },
            {
                name: 'location',
                selector: ':input[name="location"]',
                height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
                infoText: '',
                maxLength: 255,
                validate: {
                    required: true
                }
            },
            {
                name: 'implantDate',
                selector: ':input[name="implantDate"]',
                infoText: '',
                datePickerOpts: {},
                validate: {
                    required: true,
                    validDate: true,
                    todayOrBefore: true,
                    afterYear1900: true
                }
            },
            {
                name: 'status',
                selector: ':input[name="status"]',
                validate: {
                    required: true
                }
            },
            {
                name: 'reasonForInactive',
                selector: ':input[name="reasonForInactive"]',
                height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
                infoText: '',
                maxLength: 255
            },
            {
                name: 'procedureCpt',
                selector: ':input[name="procedureCpt"]',
                height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
                infoText: '',
                maxLength: 10,
                mindreaderOpts: el8.appshared.mindreaderOpts.cptCodes()
            },
            {
                name: 'lotBatchId',
                selector: ':input[name="lotBatchId"]',
                height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
                infoText: '',
                maxLength: 255
            },
            {
                name: 'deviceId',
                selector: ':input[name="deviceId"]',
                height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
                infoText: '',
                maxLength: 255
            },
            {
                name: 'distinctId',
                selector: ':input[name="distinctId"]',
                height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
                infoText: '',
                maxLength: 255
            },
            {
                name: 'serialNumber',
                selector: ':input[name="serialNumber"]',
                height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
                infoText: '',
                maxLength: 255
            },
            {
                name: 'expirationDate',
                selector: ':input[name="expirationDate"]',
                height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
                infoText: '',
                maxLength: 255
            },
            {
                name: 'manufactureDate',
                selector: ':input[name="manufactureDate"]',
                height: el8.util.consts.XL_FIELD_HEIGHT,
                infoText: '',
                maxLength: 255
            },
            {
                name: 'humanTissueDevice',
                selector: ':input[name="humanTissueDevice"]',
                height: el8.util.consts.XL_FIELD_HEIGHT,
                infoText: '',
                maxLength: 255
            },
            {
                name: 'humanTissueCode',
                selector: ':input[name="humanTissueCode"]',
                height: el8.util.consts.XL_FIELD_HEIGHT,
                infoText: '',
                maxLength: 255
            },
            {
                name: 'deviceDescription',
                selector: ':input[name="deviceDescription"]',
                height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
                infoText: '',
                maxLength: 255
            },
            {
                name: 'brandName',
                selector: ':input[name="brandName"]',
                height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
                infoText: '',
                maxLength: 255
            },
            {
                name: 'versionModel',
                selector: ':input[name="versionModel"]',
                height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
                infoText: '',
                maxLength: 255
            },
            {
                name: 'companyName',
                selector: ':input[name="companyName"]',
                height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
                infoText: '',
                maxLength: 255
            },
            {
                name: 'containsRubberLatex',
                selector: ':input[name="containsRubberLatex"]',
                height: el8.util.consts.XL_FIELD_HEIGHT,
                infoText: '',
                maxLength: 255
            },
            {
                name: 'mriSafety',
                selector: ':input[name="mriSafety"]',
                height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
                infoText: '',
                maxLength: 255
            }
        ],
        validationOpts: el8.util.validate.standardOpts
    });

    that.setForm(form);

    var formatDate = function(date) {
        var day = date.getDate();
        var month = date.getMonth() + 1;
        var year = date.getFullYear();

        return month + '/' + day + '/' + year;
    };

    var super_show = that.show;
    that.show = function(spec) {
        super_show.call(that);
        currImplantableDevice = spec;

        if (currImplantableDevice) {
            form.populate({
                'udi': currImplantableDevice.getUdi(),
                'location': currImplantableDevice.getLocation(),
                'implantDate': currImplantableDevice.getImplantDate() ? currImplantableDevice.getImplantDate().asString() : '',
                'status': currImplantableDevice.getStatus(),
                'reasonForInactive': currImplantableDevice.getReasonForInactive(),
                'lotBatchId': currImplantableDevice.getLotBatchId(),
                'deviceId': currImplantableDevice.getDeviceId(),
                'serialNumber': currImplantableDevice.getSerialNumber(),
                'distinctId': currImplantableDevice.getDistinctId(),
                'expirationDate': formatDate(currImplantableDevice.getExpirationDate()),
                'manufactureDate': formatDate(currImplantableDevice.getManufactureDate()),
                'humanTissueDevice': currImplantableDevice.isHumanTissueDevice(),
                'humanTissueCode': currImplantableDevice.getHumanTissueCode(),
                'deviceDescription': currImplantableDevice.getDeviceDescription(),
                'brandName': currImplantableDevice.getBrandName(),
                'versionModel': currImplantableDevice.getVersionModel(),
                'companyName': currImplantableDevice.getCompanyName(),
                'containsRubberLatex': currImplantableDevice.isContainsRubberLatex(),
                'mriSafety': currImplantableDevice.getMriSafety(),
                'procedureCpt': currImplantableDevice.getProcedureCpt()
            });
        }

        form.disableField('lotBatchId');
        form.disableField('deviceId');
        form.disableField('serialNumber');
        form.disableField('distinctId');
        form.disableField('expirationDate');
        form.disableField('manufactureDate');
        form.disableField('humanTissueDevice');
        form.disableField('humanTissueCode');
        form.disableField('deviceDescription');
        form.disableField('brandName');
        form.disableField('versionModel');
        form.disableField('companyName');
        form.disableField('containsRubberLatex');
        form.disableField('mriSafety');

        form.initFocus();
    };

    var super_init = that._init;
    that._init = function() {
        super_init.call(that);
        el8.data.cptCodes.softLoad();
        that._bindTriggers();
    };

    that._bindTriggers = function() {
        var container = $('#add-edit-implantable-device-form');
        var saveAndRetrieveDeviceDetailsBtn = container.find("[name='save-and-retrieve-device-details']");

        saveAndRetrieveDeviceDetailsBtn.unbind('click').on('click', function(e) {
            var udi = form.getMappedField('udi');
            var encoded_udi = encodeURIComponent(udi);

            if (!form.isValid()) {
                el8.uiwidget.nonAlarmingAlert("Please complete all required fields.");
                return false;
            }

            if (udi.length > 0) {
                $.el8_ajax({
                    url: el8.service.urls.get('implantableDeviceData', [encoded_udi]),
                    type: 'GET',
                    success: function(data) {
                        if (data['error']) {
                            var errMsg;
                            if (data['error'].split(" ").length === 1) {
                                errMsg = 'Unable to parse data from UDI: ' + data['error'];
                            } else {
                                errMsg = data['error'];
                            }
                            el8.uiwidget.alert(errMsg);
                            return false;
                        }
                        else {
                            form.setVal('lotBatchId', data['lot_batch_id'], false);
                            form.setVal('deviceId', data['device_id'], false);
                            form.setVal('serialNumber', data['serial_number'], false);
                            form.setVal('distinctId', data['distinct_id'], false);
                            form.setVal('expirationDate', formatDate(el8.service.tz.newTzDate(data['expiration_date'])), false);
                            form.setVal('manufactureDate', formatDate(el8.service.tz.newTzDate(data['manufacture_date'])), false);
                            form.setVal('humanTissueDevice', data['human_tissue_device'], false);
                            form.setVal('humanTissueCode', data['human_tissue_code'], false);
                            form.setVal('deviceDescription', data['device_description'], false);
                            form.setVal('brandName', data['brand_name'], false);
                            form.setVal('versionModel', data['version_model'], false);
                            form.setVal('companyName', data['company_name'], false);
                            form.setVal('containsRubberLatex', data['contains_rubber_latex'], false);
                            form.setVal('mriSafety', data['mri_safety'], false);
                        }

                        var all_devices = el8.ptdata.implantableDevices.all();

                        for (var i = 0; i < all_devices.length; i++) {
                            var device = all_devices[i];

                            // If we're overwriting an existing device
                            if (device.getUdi() === udi) {
                                currImplantableDevice = device;
                            }
                        }

                        if (!currImplantableDevice) {
                            currImplantableDevice = el8.ptdata.implantableDevices.create(form.getMapped(), true);
                        } else {
                            currImplantableDevice.populate(form.getMapped());
                        }

                        currImplantableDevice.setHumanTissueDevice(data['human_tissue_device']);
                        currImplantableDevice.setContainsRubberLatex(data['contains_rubber_latex']);

                        el8.ptdata.implantableDevices.saveItem(currImplantableDevice, false);
                    }
                });
            }

            return false;
        });
    };

    var super_hide = that.hide;
    that.hide = function() {
        currImplantableDevice = null;
        super_hide.call(that);
    };

    return that;

})();
